import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { inject, observer } from 'mobx-react'
import { extendObservable } from 'mobx'

import { complianceApi } from '@atheneum/api'

import MenuItem from '@material-ui/core/MenuItem'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import Typography from '@material-ui/core/Typography'
import { Language } from '@material-ui/icons'
import Grid from '@material-ui/core/Grid'
import Spinner from '@components/spinner'

class Compliance extends Component {
  static propTypes = {
    staticData: PropTypes.object,
    complianceStore: PropTypes.object
  }

  constructor (props) {
    super(props)

    extendObservable(this, {
      loading: true,
      compliances: [],
      selectedLanguage: null,
      selectedCompliance: null,
      langOptions: []
    })

    this.init()
  }

  init () {
    complianceApi.getAll().then(compliances => {
      this.compliances.replace(compliances)
      const languages = compliances.map(({ language }) => {
        const abbreviation = abbreviations.find(abbr => abbr.id === language.id)
        language.abbreviation = abbreviation.short
        return language
      })
      this.langOptions.replace(languages)
      const { ENGLISH } = this.props.staticData.CONST.LANGUAGES
      const complianceLanguageId =
        this.props.complianceStore.user.expert.complianceLanguageId || ENGLISH
      const langOption = this.langOptions.find(
        l => l.id === complianceLanguageId
      )
      this.changeLanguage(langOption)
      this.loading = false
    })
  }

  changeLanguage = langOption => {
    const selectedCompliance = this.compliances.find(
      compliance => compliance.language.id === langOption.id
    )
    this.selectedLanguage = langOption
    this.selectedCompliance = selectedCompliance
  }

  render () {

    
    if (this.loading) return <Spinner />

    return (
      <div className='compliance'>
        <Grid container className='language-section'>
          <Grid item>
            <Typography className="form-group-title">Expert Agreement</Typography>
          </Grid>
          <Grid item>
            <Grid container style={{ alignItems: "center" }}>
              <Language className='icon'/>
              <FormControl variant="standard">
                <Select
                  value={this.selectedLanguage}
                  onChange={e => this.changeLanguage(e.target.value)}
                  className='language-select'
                >
                  {this.langOptions.map(option => <MenuItem key={option.id} value={option}>{option.abbreviation}</MenuItem>)}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </Grid>
        <div
          className='compliance__text-container'
          dangerouslySetInnerHTML={{
            __html: this.selectedCompliance.complianceText
          }}
        />
      </div>
    )
  }
}

const abbreviations = [
  {
    id: 15,
    name: 'English',
    short: 'EN'
  },
  {
    id: 49,
    name: 'Portuguese',
    short: 'PT'
  },
  {
    id: 22,
    name: 'German',
    short: 'DE'
  },
  {
    id: 58,
    name: 'Spanish',
    short: 'ES'
  },
  {
    id: 20,
    name: 'French',
    short: 'FR'
  },
  {
    id: 31,
    name: 'Italian',
    short: 'IT'
  },
  {
    id: 10,
    name: 'Chinese (Mandarin)',
    short: 'ZHTW'
  },
  {
    id: 32,
    name: 'Japanese',
    short: 'JA'
  },
  {
    id: 34,
    name: 'Korean',
    short: 'KO'
  },
  {
    id: 48,
    name: 'Polish',
    short: 'PL'
  },
  {
    id: 53,
    name: 'Russian',
    short: 'RU'
  }]

export default inject('staticData', 'complianceStore')(observer(Compliance))
